import useRequest from '@/websdk/utils/request';
export default (function () {
    const { exec, isRequestSuccessed } = useRequest({
    name: 'POST_CRAFT_TEMPLATE',
    url: `/api/craft/templates`,
    method: 'POST',
  });
 

  return [exec, isRequestSuccessed];
});
